require('../modules/web.timers');
module.exports = require('../modules/_core');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/web/timers.js
// module id = 552
// module chunks = 58